/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Card, CardContent, CardTitlePrimary } from '@design-system-coopeuch/web';

import TarifaInfo from '../TarifaInfo';
import RequisitosInfo from '../RequisitosInfo';
import Botonera from '../Footer';

import { stepperAction } from '../../../../application/actions/stepper';
import { agregarformatoPesos, obtieneNombreApellidos } from '../../../../utils';
import { encryptStorage } from '../../../../utils/EncryptStorage';

import iconcedula from '../../../assets/img/icon/icon-Beneficio01.svg';
import iconprevisional from '../../../assets/img/icon/icon-Beneficio03.svg';
import iconliquidacion from '../../../assets/img/icon/icon-Beneficio02.svg';
import tarjetaDorada from '../../../assets/img/icon/Mobile-Dorada.svg';

import { properties } from '../../../../utils/properties';
import TagManagerUtils from '../../../../utils/TagManagerUtils';
import { FuturaTarjetaWrapper } from './styles';

import { verificacionActions } from '../../../../application/actions/verificacion';
import { ofertaActions } from '../../../../application/actions/oferta';
import ModalEncuestaAbandono from '../../organisms/ModalEncuestaAbandono';
import ModalRespuestaEncuesta from '../../organisms/ModalRespuestaEncuesta';

const GoldCard = () => {
  const [mounted, setMounted] = useState({
    tarifa: false,
    requisitos: false,
  });

  const [openModalEncuestaAbandono, setOpenModalEncuestaAbandono] = useState(false);
  const [openModalRespuestaEncuesta, setOpenModalRespuestaEncuesta] = useState(false);
  const [encuestaRespondida, setEncuestaRespondida] = useState(false); // pendiente backend

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const refMountedTarifaInfo = useRef(false);
  const refMountedRequisitosInfo = useRef(false);

  const [tipoRespuesta, setTipoRespuesta] = useState('');
  const [socioEstado, setSocioEstado] = useState(false);
  const [nombreSocio, setNombreSocio] = useState('');

  const dispatch = useDispatch();
  const history = useHistory();
  const { futuratarjeta } = properties;
  const { boteneraTextos, botoneraTextoNoSocioBlack } = futuratarjeta;
  const [state, setState] = useState({
    botonera: [{ nameUno: boteneraTextos.botonDos, nameDos: boteneraTextos.botonUno }],
    botoneraNoSocio: [
      { nameUno: botoneraTextoNoSocioBlack.botonDos, nameDos: botoneraTextoNoSocioBlack.botonUno },
    ],
    valorUF: 0,
  });

  const [conjuntoDeComisiones, setComisiones] = useState({
    administracionSemestral: [],
    mantencionMensual: [],
    comisionAvances: [],
    comprasInternaciones: [],
    cupoDolares: '',
    valorPesoAdministracion: '',
    cupoNacional: '',
    mantencionAnual: '',
    administracionCostoCero: [],
  });

  const storeDataVerificacion = useSelector((store) => store.entities.verificacion.response);
  const storeDataOferta = useSelector((store) => store.entities.oferta.response);
  const pasoAnterior = useSelector((store) => store.entities.stepper.menuPosicion);

  useEffect(() => {
    if (storeDataVerificacion.length === 0 && (pasoAnterior === 2 || pasoAnterior === 3)) {
      dispatch(
        verificacionActions.verificacion({ trackId: window.localStorage.getItem('track_id') })
      );
    }
    if (storeDataVerificacion.length === 0 && pasoAnterior === 1) {
      dispatch(
        verificacionActions.verificacion({
          trackId: window.localStorage.getItem('track_id'),
          solicitudAprobada: true,
        })
      );
    }
    if (storeDataOferta.length === 0 && encryptStorage.getItem('o') === 'DP') {
      dispatch(ofertaActions.ofertaCreate({ trackId: window.localStorage.getItem('track_id') }));
    }
  }, []);

  const volveraCoopeuch = () => {
    window.location.href = properties.urlCoopeuch;
    const { data } = storeDataVerificacion;
    const { socio, convenio } = data;

    if (socio && convenio) {
      const TextoSocio = 'Socio convenio';
      TagManagerUtils.triggerEventMetodo(
        'trigger_event',
        TextoSocio,
        '/tu-futura-tarjeta/mastercard/gold',
        'Click',
        'Volver a coopeuch.cl'
      );
    } else if (socio) {
      const TextoSocio = 'Socio';
      TagManagerUtils.triggerEventMetodo(
        'trigger_event',
        TextoSocio,
        '/tu-futura-tarjeta/mastercard/gold',
        'Click',
        'Volver a coopeuch.cl'
      );
    } else {
      const TextoSocio = 'No Socio';
      TagManagerUtils.triggerEventMetodo(
        'trigger_event',
        TextoSocio,
        '/tu-futura-tarjeta/mastercard/gold',
        'Click',
        'Volver a coopeuch.cl'
      );
    }
  };

  const volveraCoopeuchNoSocios = () => {
    if ('data' in storeDataVerificacion) {
      const { data } = storeDataVerificacion;
      const { socio, convenio } = data;
      if (socio && convenio) {
        const TextoSocio = 'Socio convenio';
        TagManagerUtils.triggerEventMetodoThree(
          'trigger_event',
          TextoSocio,
          '/solicitud-tarjeta-credito/paso3/hazte-socio-cuenta-vista',
          'Click',
          'Hazte Socio + Cuenta Vista'
        );
      } else if (socio) {
        const TextoSocio = 'Socio';
        TagManagerUtils.triggerEventMetodoThree(
          'trigger_event',
          TextoSocio,
          '/solicitud-tarjeta-credito/paso3/hazte-socio-cuenta-vista',
          'Click',
          'Hazte Socio + Cuenta Vista'
        );
      } else {
        const TextoSocio = 'No socio';
        TagManagerUtils.triggerEventMetodoThree(
          'trigger_event',
          TextoSocio,
          '/solicitud-tarjeta-credito/paso3/hazte-socio-cuenta-vista',
          'Click',
          'Hazte Socio + Cuenta Vista'
        );
      }
    } else {
      TagManagerUtils.triggerEventMetodoThree(
        'trigger_event',
        'No Socio',
        '/tu-futura-tarjeta/mastercard/gold',
        'Click',
        'Hazte Socio + Cuenta Vista'
      );
    }
    window.location.href = properties.urlNoSocios;
  };

  const Guardamoscomisiones = (tiposDeComisiones) => {
    try {
      if (Object.keys(tiposDeComisiones).length) {
        const { data } = tiposDeComisiones;
        const { comisiones, cupoDolares, cupoPesos, valorUF } = data;
        setState({ ...state, valorUF });

        const comisionesA = [];
        const comisionesI = [];
        const ordenarComisiones = comisiones === '' ? '' : comisiones;

        ordenarComisiones.map(function (datos, indice) {
          if (indice >= 2 && indice <= 5) {
            comisionesA.push(datos);
          }
          return comisionesA;
        });

        ordenarComisiones.map(function (datos, indice) {
          if (indice > 5 && indice <= 7) {
            comisionesI.push(datos);
          }
          return comisionesI;
        });

        setComisiones({
          comisionAvances: comisionesA,
          comprasInternaciones: comisionesI,
          administracionSemestral: ordenarComisiones[0].valor,
          mantencionMensual: ordenarComisiones[1].valor,
          valorPesoAdministracion: ordenarComisiones[0].valorPeso,
          mantencionAnual: ordenarComisiones[1].valorPeso,
          cupoDolares,
          cupoNacional: cupoPesos,
          administracionCostoCero : ordenarComisiones[8],
        });
      }
    } catch (e) {
      window.location.replace('/');
    }
  };

  useEffect(() => {
    if (refMountedTarifaInfo.current) {
      setMounted({ ...mounted, tarifa: true });
    }
    if (refMountedRequisitosInfo.current) {
      setMounted({ ...mounted, requisitos: true });
    }
    if (
      storeDataOferta.code === 0 &&
      storeDataVerificacion.code === 0 &&
      socioEstado &&
      mounted.tarifa &&
      mounted.requisitos &&
      conjuntoDeComisiones.cupoNacional
    ) {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 2500);
    }
  }, [storeDataOferta, storeDataVerificacion, socioEstado, conjuntoDeComisiones]);

  const verificar = () => {
    const nuevoPath = '/sucursal';
    encryptStorage.setItem('p', nuevoPath);
    history.push(nuevoPath);
    const { data } = storeDataVerificacion;
    const { socio, convenio } = data;
    let TextoSocio;
    if (socio && convenio) {
      TextoSocio = 'Socio convenio';
      TagManagerUtils.triggerEventMetodoTwo(
        'trigger_event',
        TextoSocio,
        '/solicitud-tarjeta-credito/paso3/solicitar-tarjeta',
        'Click',
        'Solicitar mi tarjeta',
        'Mastercard internacional Dorada'
      );
    } else if (socio) {
      TextoSocio = 'Socio';
      TagManagerUtils.triggerEventMetodoTwo(
        'trigger_event',
        TextoSocio,
        '/solicitud-tarjeta-credito/paso3/solicitar-tarjeta',
        'Click',
        'Solicitar mi tarjeta',
        'Mastercard internacional Dorada'
      );
    } else {
      TextoSocio = 'No Socio';
      TagManagerUtils.triggerEventMetodo(
        'trigger_event',
        TextoSocio,
        '/solicitud-tarjeta-credito/paso3/hazte-socio-cuenta-vista',
        'Click',
        'Continuar y ver tarjeta'
      );
    }
  };

  useEffect(() => {
    if ('code' in storeDataVerificacion && storeDataVerificacion.code === -1) {
      window.localStorage.setItem('paso', '/tu-futura-tarjeta/mastercard/gold');
      history.push('/error-conexion');
    }
    if ('data' in storeDataVerificacion && !('data' in storeDataOferta)) {
      Guardamoscomisiones(storeDataVerificacion);
    }
    if (storeDataVerificacion.length !== 0 && storeDataVerificacion.data) {
      const { socio, nombres, primerApellido, segundoApelllido } = storeDataVerificacion.data;
      setSocioEstado(socio);
      setNombreSocio(obtieneNombreApellidos(nombres, primerApellido, segundoApelllido));
      if (!socio) {
        TagManagerUtils.vpvMetodo(
          'vpv',
          '/solicitud-tarjeta-credito/paso3/hazte-socio-cuenta-vista',
          'No socio'
        );
      }
    }
  }, [storeDataVerificacion]);

  useEffect(() => {
    if ('code' in storeDataOferta && storeDataOferta.code === -1) {
      window.localStorage.setItem('paso', '/tu-futura-tarjeta/mastercard/gold');
      history.push('/error-conexion');
    }
    if (pasoAnterior === 2 || ('data' in storeDataOferta && !('data' in storeDataVerificacion))) {
      Guardamoscomisiones(storeDataOferta);
    }
    dispatch(stepperAction.fetchStepper(3));
    if (storeDataVerificacion.length) {
      const { data } = storeDataVerificacion;
      const { socio, convenio } = data;
      let TextoSocio;
      if (socio && convenio) {
        TextoSocio = 'Socio convenio';
        TagManagerUtils.vpvMetodo(
          'vpv',
          '/solicitud-tarjeta-credito/paso3/solicitar-tarjeta',
          TextoSocio
        );
      } else if (socio) {
        TextoSocio = 'Socio';
        TagManagerUtils.vpvMetodo(
          'vpv',
          '/solicitud-tarjeta-credito/paso3/solicitar-tarjeta',
          TextoSocio
        );
      } else {
        TextoSocio = 'No Socio';
        TagManagerUtils.vpvMetodo(
          'vpv',
          '/solicitud-tarjeta-credito/paso3/hazte-socio-cuenta-vista',
          TextoSocio
        );
      }
    }
  }, [storeDataOferta]);

  const volverACoopeuch = () => {
    window.location.href = properties.urlCoopeuch;
  };

  const retomarEncuesta = () => {
    setOpenModalEncuestaAbandono(true);
    setOpenModalRespuestaEncuesta(false);
  };

  const { botonera, botoneraNoSocio, valorUF } = state;
  const { cupoDolares, cupoNacional } = conjuntoDeComisiones;

  return (
    <>
      <FuturaTarjetaWrapper>
        <div className="futura-tarjeta-header-gold">
          <div className="t-internacional texto-tarifas">
            <p className="titulo">{properties.futuratarjeta.goldcardTitulo}</p>
            <p className="subtitulo">{properties.futuratarjeta.goldcardBajada}</p>
          </div>
          <div className="t-internacional">
            <img className="tarjetainternacional" src={tarjetaDorada} alt="internacional" />
            <div className="texto">
              <p className="p-internacional">
                {`$ ${agregarformatoPesos(cupoNacional)} + US ${agregarformatoPesos(cupoDolares)}`}
              </p>
              <p className="p-internacional-dos">{nombreSocio}</p>
            </div>
          </div>
        </div>
        <div className="card">
          <Card className="Card-Class">
            <CardTitlePrimary title={properties.futuratarjeta.goldcardBenificios} />
            <CardContent>
              <div className="contenedor-gold-card">
                <div className="info">
                  <img className="iconcedula" src={iconcedula} alt="cedula" />
                  <p className="p-mensaje">{properties.futuratarjeta.BeneficiosGold.titulo}</p>
                  <p className="p-coment">{properties.futuratarjeta.BeneficiosGold.bajada}</p>
                </div>
                <div className="info">
                  <img className="iconliquidacion" src={iconliquidacion} alt="liquidacion" />
                  <p className="p-mensaje">{properties.futuratarjeta.BeneficiosGold.tituloDos}</p>
                  <p className="p-coment">{properties.futuratarjeta.BeneficiosGold.bajadaDos}</p>
                </div>
                <div className="info">
                  <img className="iconprevision" src={iconprevisional} alt="prevision" />
                  <p className="p-mensaje">{properties.futuratarjeta.BeneficiosGold.tituloTres}</p>
                  <p className="p-coment">{properties.futuratarjeta.BeneficiosGold.bajadaTres}</p>
                </div>
              </div>
            </CardContent>
          </Card>
          {socioEstado ? (
            <TarifaInfo
              tarifaRef={refMountedTarifaInfo}
              dataComisiones={conjuntoDeComisiones}
              UFValor={valorUF}
            />
          ) : (
            <RequisitosInfo requisitosRef={refMountedRequisitosInfo} />
          )}
        </div>
        <Botonera
          tituloboton={socioEstado ? botonera : botoneraNoSocio}
          verificarFunction={socioEstado ? verificar : volveraCoopeuchNoSocios}
          volverHome={
            process.env.REACT_APP_HABILITAR_ENCUESTAS === 'true'
              ? setOpenModalEncuestaAbandono
              : volverACoopeuch
          }
          estadoBotonUno
          estadoBotonDos={false}
          nombreDinamicoResponsive={false}
        />
        {openModalEncuestaAbandono && (
          <ModalEncuestaAbandono
            setTipoRespuesta={setTipoRespuesta}
            setOpenModalEncuestaAbandono={setOpenModalEncuestaAbandono}
            setOpenModalRespuestaEncuesta={setOpenModalRespuestaEncuesta}
            setEncuestaRespondida={setEncuestaRespondida}
          />
        )}
        {openModalRespuestaEncuesta && (
          <ModalRespuestaEncuesta
            tipoRespuesta={tipoRespuesta}
            setOpenModalRespuestaEncuesta={setOpenModalRespuestaEncuesta}
            titulo={
              tipoRespuesta === 'exito'
                ? properties.encuestaAbandono.exitoTitulo
                : properties.encuestaAbandono.errorTitulo
            }
            descripcion={
              tipoRespuesta === 'exito'
                ? properties.encuestaAbandono.exitoDescripcion
                : properties.encuestaAbandono.errorDescripcion
            }
            botonAccion={tipoRespuesta === 'exito' ? volverACoopeuch : retomarEncuesta}
            botonTexto={
              tipoRespuesta === 'exito'
                ? properties.encuestaAbandono.exitoBoton
                : properties.encuestaAbandono.errorBoton
            }
          />
        )}
      </FuturaTarjetaWrapper>
    </>
  );
};

export default GoldCard;
